import { render, staticRenderFns } from "./_base-overlay.vue?vue&type=template&id=dbfd1272&scoped=true&"
import script from "./_base-overlay.vue?vue&type=script&lang=js&"
export * from "./_base-overlay.vue?vue&type=script&lang=js&"
import style0 from "./_base-overlay.vue?vue&type=style&index=0&id=dbfd1272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfd1272",
  null
  
)

export default component.exports